// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","not_recipes":"Home_not_recipes__A5mcQ"};